/**
 * Electron-Menü + globale Backup-API (Prod + Dev).
 */

import {
  buildStorageBackupSnapshot,
  exportStorageBackupToFile,
  importStorageBackupFromFile,
  restoreStorageBackupSnapshot
} from './storageBackupService';

export function registerStorageBackupBridge() {
  if (typeof window === 'undefined') return;

  window.__amanStorageBackup = {
    buildSnapshot: buildStorageBackupSnapshot,
    exportToFile: exportStorageBackupToFile,
    importFromFile: importStorageBackupFromFile,
    restoreSnapshot: restoreStorageBackupSnapshot,
    runDailyBackup: () => import('./dailyBackupService').then((m) => m.runDailyBackupIfDue()),
    recoverAfterReinstall: () =>
      import('./reinstallRecoveryService').then((m) => m.recoverSessionAfterReinstall())
  };
}
